import React, { useState } from 'react'
import MainLogo from '../button/navigationBtn/MainLogo'
import ComponyBtn from '../button/navigationBtn/CompanyBtn'
import TechnologiesBtn from '../button/navigationBtn/TechnologiesBtn'
import VenderProductBtn from '../button/navigationBtn/VenderProductBtn'
import ContactBtn from '../button/navigationBtn/ContactBtn'
import { Link, useLocation } from 'react-router-dom'
import styled from 'styled-components'
import LogoImage from '../../assets/lacessLogo.png'

const MainNaviagation = () => {
  const [isOpen, setIsOpen] = useState(false)
  const { pathname } = useLocation()
  const isMainPage = pathname === '/main'

  const toggleNav = () => {
    setIsOpen((prev) => !prev)
  }

  const scrollToSection = (event, id) => {
    if (!isMainPage) return

    event.preventDefault()
    const target = document.getElementById(id)
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
      setIsOpen(false)
    }
  }

  return (
    <HeaderContainer>
      <MainLogo>
        <StyledLink to="/">
          <StyledlogoImage src={LogoImage} />
        </StyledLink>
      </MainLogo>
      <NavLinksGroup>
        <ComponyBtn>
          {isMainPage ? (
            <MenuLink
              className="animated-button"
              href="#company"
              onClick={(event) => scrollToSection(event, 'company')}
            >
              Company
            </MenuLink>
          ) : (
            <StyledLink className="animated-button" to="/company">
              Company
            </StyledLink>
          )}
        </ComponyBtn>
        <VenderProductBtn>
          {isMainPage ? (
            <MenuLink
              className="animated-button"
              href="#biz-area"
              onClick={(event) => scrollToSection(event, 'biz-area')}
            >
              Biz Area
            </MenuLink>
          ) : (
            <StyledLink className="animated-button" to="/bizArea">
              Biz Area
            </StyledLink>
          )}
        </VenderProductBtn>
        <TechnologiesBtn>
          {isMainPage ? (
            <MenuLink
              className="animated-button"
              href="#vendor-product"
              onClick={(event) => scrollToSection(event, 'vendor-product')}
            >
              Vendor & Product
            </MenuLink>
          ) : (
            <StyledLink className="animated-button" to="/vendor">
              Vendor & Product
            </StyledLink>
          )}
        </TechnologiesBtn>
        <ContactBtn>
          {isMainPage ? (
            <MenuLink href="#contact" onClick={(event) => scrollToSection(event, 'contact')}>
              Contact
            </MenuLink>
          ) : (
            <StyledLink to="/contact">Contact</StyledLink>
          )}
        </ContactBtn>
        <HamburgerBtn onClick={toggleNav}>☰</HamburgerBtn>
      </NavLinksGroup>
      <NavContainer $isOpen={isOpen}>
        <NavList>
          {isMainPage ? (
            <>
              <NavItem href="#company" onClick={(event) => scrollToSection(event, 'company')}>
                Company
              </NavItem>
              <NavItem href="#biz-area" onClick={(event) => scrollToSection(event, 'biz-area')}>
                Biz Area
              </NavItem>
              <NavItem href="#vendor-product" onClick={(event) => scrollToSection(event, 'vendor-product')}>
                Vendor & Product
              </NavItem>
              <NavItem href="#contact" onClick={(event) => scrollToSection(event, 'contact')}>
                Contact
              </NavItem>
            </>
          ) : (
            <>
              <StyledSideLink onClick={() => setIsOpen(false)} to="/company">
                Company
              </StyledSideLink>
              <StyledSideLink onClick={() => setIsOpen(false)} to="/bizArea">
                Biz Area
              </StyledSideLink>
              <StyledSideLink onClick={() => setIsOpen(false)} to="/vendor">
                Vendor & Product
              </StyledSideLink>
              <StyledSideLink onClick={() => setIsOpen(false)} to="/contact">
                Contact
              </StyledSideLink>
            </>
          )}
        </NavList>
      </NavContainer>
    </HeaderContainer>
  )
}

const MenuLink = styled.a`
  color: ${({ theme }) => theme.COLOR.BLACK};
  text-decoration: none;
  height: 100%;
  width: 100%;
  text-align: center;
  font-weight: 600;
  place-content: center;

  @media (min-width: 1300px) and (max-width: 1499px) {
    width: 80%;
  }

  @media (min-width: 800px) and (max-width: 1299px) {
    width: 70%;
  }
`

const NavItem = styled.a`
  color: #fff;
  text-decoration: none;
  font-size: 1.5rem;

  &:hover {
    color: #ddd;
  }
`

const StyledSideLink = styled(Link)`
  color: #fff;
  text-decoration: none;
  font-size: 1.5rem;
`

const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.COLOR.BLACK};
  text-decoration: none;
  height: 100%;
  width: 100%;
  text-align: center;
  font-weight: 600;
  place-content: center;

  @media (min-width: 1300px) and (max-width: 1499px) {
    width: 80%;
  }

  @media (min-width: 800px) and (max-width: 1299px) {
    width: 70%;
  }
`

const HamburgerBtn = styled.div`
  position: absolute;
  right: 0;
  padding-right: 6%;
  font-size: xx-large;
  cursor: pointer;
  display: none;
  z-index: 999;
  color: green;

  @media (min-width: 0px) and (max-width: 799px) {
    display: inline-block;
  }
`

const HeaderContainer = styled.div`
  width: 100%;
  height: 6vh;
  background-color: ${({ theme }) => theme.COLOR.WHITE};
  position: fixed;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${({ theme }) => theme.COLOR.BLACK};
  font-size: ${({ theme }) => theme.SIZE.LARGE};
  z-index: 999;

  @media (min-width: 450px) and (max-width: 799px) {
    justify-content: flex-start;
    align-items: center;
  }

  @media (max-width: 449px) {
    justify-content: flex-start;
    align-items: center;
  }
`

const NavLinksGroup = styled.div`
  display: flex;
  flex: 1 1 auto;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
`

const NavContainer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 300px;
  height: 100%;
  background-color: #333;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: ${({ $isOpen }) => ($isOpen ? 'translateX(0)' : 'translateX(100%)')};
  transition: transform 0.3s ease-in-out;
  z-index: 99;
`

const NavList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`

const StyledlogoImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  transform: scale(0.7);

  @media (min-width: 800px) and (max-width: 1300px) {
    transform: scale(0.7);
  }

  @media (min-width: 450px) and (max-width: 799px) {
    transform: scale(0.6);
  }

  @media (max-width: 449px) {
    transform: scale(0.6);
  }
`

export default MainNaviagation
